import { signal } from '@angular/core';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { HighLevelSignificantSvgComponent } from './high-level-significant-svg/high-level-significant-legend-svg';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';

export const HIGH_LEVEL_SIGNIFICANT_LEGEND: TwcLegendParams = {
  title: 'HIGH-LEVEL SIGNIFICANT WEATHER',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: HighLevelSignificantSvgComponent },
  legendComponent: TwcLegendComponent
};
